import { memo } from 'react';
import { Link } from 'react-router-dom';
import { BRAND } from '@/src/constants';
import { cn } from '@/src/utils';

interface LogoProps {
  className?: string;
  showText?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const sizes = {
  sm: { box: 'w-6 h-6 text-xs', text: 'text-lg' },
  md: { box: 'w-8 h-8 text-sm', text: 'text-xl' },
  lg: { box: 'w-10 h-10 text-base', text: 'text-2xl' },
};

function Logo({ className, showText = true, size = 'md' }: LogoProps) {
  const imgSizes = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-10 h-10',
  };

  return (
    <Link
      to="/"
      className={cn(
        'flex items-center gap-2 cursor-pointer group z-50 relative',
        className
      )}
    >
      <img
        src="/favicon.svg"
        alt={BRAND.name}
        className={cn(
          'rounded-full group-hover:scale-110 transition-transform duration-300',
          'drop-shadow-[0_0_8px_rgba(255,255,255,0.4)] group-hover:drop-shadow-[0_0_15px_rgba(255,255,255,0.6)]',
          imgSizes[size]
        )}
      />
      {showText && (
        <span
          className={cn(
            'font-semibold tracking-tight text-white group-hover:text-gray-200 transition-colors',
            sizes[size].text
          )}
        >
          {BRAND.name}
        </span>
      )}
    </Link>
  );
}

export default memo(Logo);
